import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import BookDemoQuiz from './BookDemoQuiz';

export default function BookDemoWrapper({ steps, defaultImage }) {
  const [currentImage, setCurrentImage] = useState(defaultImage);

  return (
    <div className="demo-page__wrapper">
      <div className="demo-page__image">
        <AnimatePresence mode="wait">
          <motion.img
            key={currentImage}
            src={currentImage}
            alt="Ogiso Platform"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          />
        </AnimatePresence>
      </div>
      <div className="demo-page__content">
        <BookDemoQuiz steps={steps} onImageChange={setCurrentImage} />
      </div>
    </div>
  );
}
